import { Link } from "react-router-dom" // 💡 Link 컴포넌트 임포트 유지
import ProductCard from "../product/ProductCard"

// 💡 1. title과 subtitle 속성(Props) 타입 추가
type ProductSectionProps = {
  title?: string
  subtitle?: string
  products?: any[]
}

// 💡 2. Props에서 title, subtitle을 꺼내고 기본값 설정
export default function ProductSection({
                                         title = "지금 인기 상품",
                                         subtitle = "방금 등록된 가장 신선한 상품들을 만나보세요.",
                                         products = []
                                       }: ProductSectionProps) {
  return (
    <section className="mx-auto max-w-7xl px-4 py-8 lg:px-6">
      <div className="mb-5 flex items-end justify-between">
        <div>
          {/* 💡 3. 하드코딩된 텍스트 대신 Props로 받은 변수 사용 */}
          <h2 className="text-2xl font-bold">{title}</h2>
          <p className="mt-1 text-sm text-slate-500">
            {subtitle}
          </p>
        </div>
        <Link
          to="/products"
          className="text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors"
        >
          전체 보기 &gt;
        </Link>
      </div>

      <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-4">
        {products.length === 0 ? (
          <div className="col-span-full py-16 text-center text-slate-500 border border-slate-200 rounded-[24px] bg-white">
            등록된 판매 중인 상품이 없습니다.
          </div>
        ) : (
          products.map((product) => (
            <ProductCard
              key={product.productId}
              product={{
                productId: product.productId,
                productName: product.productName,
                price: `${product.price.toLocaleString("ko-KR")}원`,
                // 💡 4. 강제 BEST 배지 로직 제거, MainPage에서 가공한 badge 값을 그대로 사용
                badge: product.badge,
                thumbnailUrl: product.thumbnailUrl
              }}
            />
          ))
        )}
      </div>
    </section>
  )
}